"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  info: 'info',
  warn: 'warn',
  error: 'error'
};